import { Inline, Stack, u } from '@ui';

import { Club, ComparisonSwing, Layout, Tags, User } from './TopBarComponents';

export const TopBar = () => {
    return (
        <Stack pt={u(2.5)} pb={u(2.5)} paddingInline={u(2.5)} justifyContent="space-between">
            <Inline alignItems="center" gap={u(4)}>
                <User />
                <Layout />
                <Club />
                <Tags />
                <ComparisonSwing />
            </Inline>
        </Stack>
    );
};
